import React, { Component } from "react";
import { ImgRenta } from "../../images/servicios";
import { ModernServicePage } from "../modern";

export class DeclaracionRenta extends Component {
  render() {
    const serviceData = {
      title: "Planificación de Renta 2027",
      subtitle:
        "Nos preparamos todo el año para este momento con estrategias que optimizan tus resultados tributarios",
      description:
        "No solo declaramos tu Renta, nos encargaremos de recomendar todos los beneficios tributarios aplicables a tu empresa.",
      whatsappMessage:
        "Hola, necesito información sobre planificación de renta",
      features: [
        {
          emoji: "🏆",
          title: "¿Por qué preferir Contasi?",
          description:
            "Nuestros profesionales están siempre en constante actualización de normativas, leyes, noticias y estudio de estrategias para optimizar los resultados desde el punto de vista tributario. Te explicaremos con palabras sencillas para tomar la mejor decisión.",
        },
        {
          emoji: "💰",
          title: "Beneficios del Régimen Tributario",
          description:
            "Dependiendo del régimen tributario que tenga la empresa puedes obtener algunos beneficios como rebajar el pago de impuestos como incentivo para la reinversión. Por ejemplo, si el régimen de tu empresa es Pro pyme General tienes este incentivo, entre otros beneficios.",
        },
        {
          emoji: "📊",
          title: "Impuestos y Devoluciones",
          description:
            "Si tu empresa tuvo utilidades deberá pagar el porcentaje de impuesto que corresponda al régimen tributario elegido. De lo contrario, si tienes pérdidas y la empresa ha pagado PPM podrá solicitar la devolución mediante transferencia a la cuenta corriente de la empresa.",
        },
        {
          emoji: "⚠️",
          title: "Importancia de Declarar Correctamente",
          description:
            "No declarar los impuestos puede llevarte a recibir multas e intereses, incluso el representante legal de la empresa puede quedar con deuda ante la Tesorería General de la República e incluso imposibilitado para representar otras sociedades en el futuro.",
        },
        {
          emoji: "📋",
          title: "Considera Todos los Gastos",
          description:
            "Una cosa son las facturas de compra que puede recibir la empresa, pero también están las boletas de honorarios. Hay varios documentos que pueden ser considerados dentro del gasto asociado a la actividad de la empresa, como gastos de taxi para reuniones.",
        },
        {
          emoji: "✅",
          title: "Gastos Aceptados vs Rechazados",
          description:
            "Es importante tener claro cuáles son los gastos aceptados por el SII al momento de presentar la Renta, debido a que un gasto Rechazado va asociado a una multa de hasta un 35% del valor de dicho gasto.",
        },
        {
          emoji: "🔄",
          title: "Rectificaciones de Períodos Anteriores",
          description:
            "Si las declaraciones anteriores se encuentran objetadas, con observaciones o aceptadas con observaciones, la renta del año en curso arrastrará dichos errores, por lo que es vital subsanarlas antes de proceder.",
        },
      ],
      images: [
        {
          src: ImgRenta,
          alt: "Planificación de Renta 2027",
        },
      ],
      benefits: [
        "Profesionales actualizados en normativas",
        "Optimización de beneficios tributarios",
        "Estrategias de planificación anual",
        "Análisis de régimen tributario óptimo",
        "Gestión de devoluciones PPM",
        "Prevención de multas y sanciones",
        "Asesoría en gastos deducibles",
      ],
      navigationItems: [
        { id: "feature-0", label: "Ventajas" },
        { id: "feature-1", label: "Beneficios" },
        { id: "feature-2", label: "Devoluciones" },
        { id: "feature-3", label: "Cumplimiento" },
      ],
    };

    return <ModernServicePage {...serviceData} />;
  }
}

export default DeclaracionRenta;
